var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSumIntermediate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 44,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53.053,
    height: 42.7,
    x: 1.032,
    y: 0.65,
    fill: "url(#a)",
    fillOpacity: 0.4,
    rx: 12.291
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 53.053,
    height: 42.7,
    x: 1.032,
    y: 0.65,
    stroke: "url(#b)",
    strokeWidth: 1.3,
    rx: 12.291
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.794,
    x2: 40.125,
    y1: 5.208,
    y2: 57.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 27.559,
    x2: 27.559,
    y1: 0,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#FFFFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#FFF2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#FBC026"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumIntermediate);
export default __webpack_public_path__ + "static/media/sum_intermediate.f7fea7eb4c9e0bcf7447d6ae4a96b4f7.svg";
export { ForwardRef as ReactComponent };